export default __webpack_public_path__ + "static/media/table-ddl-icon.05a2d42f.svg";